/* eslint-disable */
export enum CountryIsoCode {
  PORTUGAL = "PT",
  SPAIN = "ES",
  MEXICO = "MX",
}
